function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", {
  transform: "matrix(1 0 0 -1 0 864)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M1008 396v-72h-468v-468h-72v468h-468v72h468v468h72v-468h468z"
}));

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    version: 1.1,
    viewBox: "0 0 1008 1008"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/plus.0e498cbb.svg";
export { SvgComponent as ReactComponent };